const normalizeAppsMetadataItems = (items) => {
  if (!Array.isArray(items)) {
    return [];
  }

  return items.filter((item) => {
    return item && typeof item === 'object' && !Array.isArray(item);
  });
};

export default normalizeAppsMetadataItems;
